import React, { useState, useCallback, Fragment } from "react";
import {
  Container,
  EntryItemContainer,
  ImageItem,
  ItemDescription,
  ProjectDate,
  Divider,
  Name,
  Title,
  ProjectDescription,
  Section,
  SectionOne,
  Row,
  State,
  Icons,
  IconAction,
  IconLink,
  ConfirmDrawer,
} from "./styles";

import Ponderation from "components/Ponderation";

import Confirmation from "components/Confirmation";

import Rating from "components/Rating";
import { Votes } from "components/Ponderation";

import EntryPostulationLoader from "loader/EntryPostulationLoader";

import EyeIcon from "icons/EyeIcon";
import StarIcon from "icons/StarIcon";
import VoteIcon from "icons/VoteIcon";
import EmailIcon from "icons/EmailIcon";
import CheckIcon from "icons/CheckIcon";
import TrashIcon from "icons/TrashIcon";
import LinkIcon from "icons/LinkIcon";

import CloseIcon from "icons/CloseIcon";
import DowloadIcon from "icons/DownloadIcon";
import { colors } from "definitions";
import { getLabel, capitalize } from "helpers";

import { FormStatus } from "model/options";

import AnimatedControl from "components/AnimatedControl";

import useTimeAgo from "hooks/useTimeAgo";
import useEntries from "hooks/useEntries";
import useEntryForm from "hooks/useEntryForm";
import Modal from "components/Modal";
import ViewEntry from "pages/ViewEntry";

export default function ListOfEntries({
  entries,
  mode,
  readOnly = false,
  loading,
  emptyMessage,
  onSelected,
  onCleanSelected,
  isSelected,
  onConfirm,
  onCopyLink,
  onDelete,
}) {
  const [modalOpened, setModalOpened] = useState(false);
  const [entryId, setEntryId] = useState();

  const showEntryForm = (id) => {
    setEntryId(id);
    setModalOpened(true);
  };

  const closeEntryForm = () => {
    setModalOpened(false);
  };

  return (
    <Container>
      {/* `wide` le pone el mismo techo de ancho que al resto de la app: sin
          eso el modal se estiraba al 90% de la pantalla y en un monitor grande
          los campos quedaban en renglones larguísimos. */}
      <Modal
        locked
        wide
        onClose={() => {
          setModalOpened();
        }}
        open={modalOpened}
      >
        <ViewEntry params={{ entryId, onClose: () => closeEntryForm() }} />
      </Modal>

      {entries.map((entry) => {
        return (
          <EntryItem
            key={entry.id}
            entry={entry}
            showEntryForm={showEntryForm}
            onSelected={onSelected}
            selected={
              (isSelected && isSelected(entry.id)) ||
              (mode === "voting" && entry.isVoted)
            }
            onCleanSelected={onCleanSelected}
            onConfirm={onConfirm}
            onCopyLink={onCopyLink}
            onDelete={onDelete}
            mode={mode}
            readOnly={readOnly}
            loading={loading}
          />
        );
      })}

      {entries.length === 0 && !loading && (
        <EntryItemContainer style={{ padding: "2rem" }}>
          <Section
            style={{
              flexBasis: "100%",
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Name style={{ textAlign: "center", alignSelf: "center" }}>
              {emptyMessage}
            </Name>
          </Section>
        </EntryItemContainer>
      )}

      {entries.length === 0 && loading && (
        <EntryItemContainer style={{ padding: "2rem" }}>
          <EntryPostulationLoader />
        </EntryItemContainer>
      )}
    </Container>
  );
}

const EntryItem = ({
  entry,
  onSelected,
  showEntryForm,
  selected,
  onCleanSelected,
  onConfirm,
  onCopyLink,
  onDelete,
  mode,
  readOnly,
  loading,
}) => {
  const { sendConfirmEmail } = useEntryForm();

  const timeago = useTimeAgo(+entry.createdAt.toDate());

  const [formOpened, setFormOpened] = useState(false);

  // La confirmación manual y el borrado no tocan la selección del listado
  // (`onSelected`): son acciones sobre esta fila y nada más. Van con un único
  // estado (`"confirm"` | `"delete"`) para que no puedan quedar los dos
  // paneles abiertos a la vez.
  const [pendingAction, setPendingAction] = useState();

  const { updateVote } = useEntries();

  const getStatus = useCallback(() => {
    return getLabel(FormStatus, entry.currentStatus.type);
  }, [entry]);

  const onOpenForm = () => {
    onSelected(entry.id);

    setFormOpened(true);
  };

  const onCloseForm = async (reset = false) => {
    onCleanSelected(entry.id, reset);

    setFormOpened(false);
  };

  const onSubmit = () => {
    updateVote(entry.id, entry.award.id).then(() => {
      onCloseForm(true);
    });
  };

  const onResendEmail = () => {
    sendConfirmEmail(entry);
  };

  const onConfirmEntry = () => {
    setPendingAction();

    onConfirm(entry);
  };

  const onDeleteEntry = () => {
    setPendingAction();

    onDelete(entry);
  };

  const showBorder = selected && !formOpened;

  return (
    <Fragment>
      <EntryItemContainer
        mode={mode}
        selected={formOpened}
        showBorder={showBorder}
      >
        <SectionOne showBorder={showBorder}>
          <State
            color={`${colors.background.gray}`}
            showBorder={showBorder}
            mode={mode}
            selected={selected}
          >
            <span
              style={{
                color: "white",
                fontWeight: "500",
                textTransform: "uppercase",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
              }}
            >
              {getStatus()}
            </span>
          </State>

          <ImageItem image={entry.avatar} showBorder={showBorder} />
        </SectionOne>

        <Section>
          <ItemDescription>
            <Row>
              <Name>
                {capitalize(entry.projectName || "Empresario del Año")} (
                {capitalize(entry.companyName)})
              </Name>
            </Row>
            <Title>
              {entry.lastName}, {entry.firstName}. ({entry.email})
            </Title>
            <ProjectDescription>{entry.award.title} </ProjectDescription>
            <ProjectDate>Creado {timeago}</ProjectDate>
          </ItemDescription>
        </Section>

        <Divider />

        {/* Todas las acciones van en el mismo botón (`IconAction`): mismo
            tamaño, mismo hover y un rótulo que diga qué hace cada una, que
            con cinco iconos seguidos ya no se adivina. */}
        <Icons selected={selected}>
          {formOpened ? (
            <IconAction
              type="button"
              title="Cerrar"
              aria-label="Cerrar"
              onClick={() => {
                onCloseForm();
              }}
            >
              <CloseIcon fill="currentColor" />
            </IconAction>
          ) : (
            <Fragment>
              <IconAction
                type="button"
                title="Ver la postulación"
                aria-label="Ver la postulación"
                onClick={() => {
                  showEntryForm(entry.id);
                }}
              >
                <EyeIcon />
              </IconAction>

              <IconLink
                target="_blank"
                rel="noopener noreferrer"
                href={entry.pdf}
                title="Descargar el PDF"
                aria-label="Descargar el PDF"
              >
                <DowloadIcon />
              </IconLink>

              {/* Valorar y votar sólo dentro de las fechas del paso
                  (`readOnly` afuera, ver `EntriesPage`). */}
              {mode === "criteria" && !readOnly && (
                <IconAction
                  type="button"
                  title="Evaluar la postulación"
                  aria-label="Evaluar la postulación"
                  onClick={() => {
                    onOpenForm();
                  }}
                >
                  <StarIcon stroke="currentColor" strokeWidth="42" />
                </IconAction>
              )}

              {mode === "voting" && !entry.isVoted && !readOnly && (
                <IconAction
                  type="button"
                  title="Votar la postulación"
                  aria-label="Votar la postulación"
                  onClick={() => {
                    onOpenForm();
                  }}
                >
                  <VoteIcon />
                </IconAction>
              )}

              {/* Borrador: el postulante nunca confirmó. Se le puede
                  reenviar el mail, pasarle el link por otro lado o
                  confirmarla a mano desde acá. */}
              {mode === "list" && entry.currentStatus.type === "draft" && (
                <Fragment>
                  <IconAction
                    type="button"
                    title="Confirmar la postulación"
                    aria-label="Confirmar la postulación"
                    onClick={() => {
                      setPendingAction("confirm");
                    }}
                  >
                    <CheckIcon />
                  </IconAction>

                  <IconAction
                    type="button"
                    title="Reenviar el mail de confirmación"
                    aria-label="Reenviar el mail de confirmación"
                    onClick={() => {
                      onResendEmail();
                    }}
                  >
                    <EmailIcon />
                  </IconAction>

                  {/* El mismo link que va en ese mail, al portapapeles: para
                      cuando el mail no llega y hay que pasárselo por otro
                      medio. Sin panel de confirmación, que copiar no rompe
                      nada. */}
                  <IconAction
                    type="button"
                    title="Copiar el link de confirmación"
                    aria-label="Copiar el link de confirmación"
                    onClick={() => {
                      onCopyLink(entry);
                    }}
                  >
                    <LinkIcon />
                  </IconAction>
                </Fragment>
              )}

              {/* El borrado es de administración y va para cualquier estado:
                  saca la postulación del listado y de las evaluaciones. */}
              {mode === "list" && (
                <IconAction
                  type="button"
                  data-tone="danger"
                  title="Borrar la postulación"
                  aria-label="Borrar la postulación"
                  onClick={() => {
                    setPendingAction("delete");
                  }}
                >
                  <TrashIcon />
                </IconAction>
              )}
            </Fragment>
          )}
        </Icons>
      </EntryItemContainer>

      {mode === "finalists" && (
        <Ponderation
          criteria={{ users: entry.users, ponderation: entry.ponderation }}
          entryId={entry.id}
          onSelected={onSelected}
          selected={selected}
          onCleanSelected={onCleanSelected}
          readOnly={readOnly}
        />
      )}

      {mode === "winners" && (
        <Votes
          votes={entry.votes}
          entryId={entry.id}
          onSelected={onSelected}
          selected={selected}
          onCleanSelected={onCleanSelected}
          readOnly={readOnly}
        />
      )}

      <AnimatedControl
        condition={mode === "criteria" && selected && !loading && !readOnly}
        control={
          <Rating
            formOpened={formOpened}
            onSelected={onSelected}
            mode={mode}
            entry={entry}
            onClose={onCloseForm}
          />
        }
      />

      <ConfirmDrawer>
        <AnimatedControl
          condition={pendingAction === "confirm"}
          control={
            <Confirmation
              type="confirm"
              text={`¿Confirma la postulación de ${capitalize(
                entry.companyName
              )}? El postulante ya no podrá editarla.`}
              onClick={onConfirmEntry}
              cancel={() => setPendingAction()}
            />
          }
        />

        <AnimatedControl
          condition={pendingAction === "delete"}
          control={
            <Confirmation
              type="cancel"
              text={`¿Borra la postulación de ${capitalize(
                entry.companyName
              )}? Se saca del listado y de las evaluaciones.`}
              onClick={onDeleteEntry}
              cancel={() => setPendingAction()}
            />
          }
        />
      </ConfirmDrawer>

      <AnimatedControl
        condition={
          mode === "voting" && selected && !entry.isVoted && !readOnly
        }
        control={
          <Confirmation
            type="confirm"
            paramOk={entry.id}
            text={`Confirma el voto a ${entry.projectName} de ${entry.companyName}?`}
            onClick={onSubmit}
            cancel={onCloseForm}
          />
        }
      />
    </Fragment>
  );
};
